<nb-card [nbSpinner]="roomLoading">
  <nb-card-header>
    <div class="row">
      <div class="col">
        <h2 *ngIf="editRoom.id === undefined"><i class="fas fa-plus me-2"></i>Create Room</h2>
        <h2 *ngIf="editRoom.id !== undefined"><i class="fas fa-pen me-2"></i>Edit Room {{editRoom.name}}</h2>
      </div>
      
    </div>
  </nb-card-header>
  <nb-card-body>
    <form #RoomForm="ngForm" id="RoomForm" name="RoomForm" style="margin-top: 15px;">
      <div class="row">
        <div class="form-group col-12">
          <h3>Details</h3>
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="name" name="name" [(ngModel)]="editRoom.name"
                    placeholder='Name' [value]="editRoom?.name" required #name="ngModel">
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="roomDescription" name="roomDescription"
                    [(ngModel)]="editRoom.description" placeholder='Description' [value]="editRoom?.description"
                    #name="ngModel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="number" matInput id="roomCapacity" name="roomCapacity"
                    [(ngModel)]="editRoom.roomCapacity" placeholder='Capacity' [value]="editRoom?.roomCapacity" required
                    #name="ngModel">
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <mat-label>
                    Warehouse
                  </mat-label>
                  <mat-select placeholder="Warehouse" name="warehouseDropdown" id="warehouseDropdown"
                    [(ngModel)]="this.editRoom.warehouseId" (selectionChange)="warehouseChanged($event.value)" required
                    #warehouseDropdown="ngModel">
                    <mat-option>(SELECT)</mat-option>
                    <mat-option *ngFor="let v of this.warehouses" [value]="v.id">
                      {{v.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="number" matInput id="roomLatatude" name="roomLatatude"
                    [(ngModel)]="editRoom.latitude" placeholder='Latitude' [value]="editRoom?.latitude" #name="ngModel">
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="number" matInput id="roomLongitude" name="roomLongitude"
                    [(ngModel)]="editRoom.longitude" placeholder='Longitude' [value]="editRoom?.longitude"
                    #name="ngModel">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">

                  <input type="text" matInput id="integrationId" name="integrationId"
                    [(ngModel)]="editRoom.integrationId" placeholder='Integration Id' [value]="editRoom?.integrationId"
                    #name="ngModel">
                </mat-form-field>
              </div>
              <!-- dynamic export columns -->
              <div class="col-lg-6 col-12" *ngFor="let detail of this.editRoom.details">

                <!-- string -->
                <mat-form-field *ngIf="getOptionsLength(detail) == 0 
                 && attrDatatype(detail) == 'string'" style="width: 100%">
                  <mat-label>{{detail.roomCustomAttribute.name}}</mat-label>
                  <input [(ngModel)]="detail.value" [required]="isAttrRequired(detail)" [value]="detail.value" matInput
                    type="text" #custDetailText id="custDetail{{detail.id}}" name="custDetail{{detail.id}}">
                  <button *ngIf="detail.value"  matSuffix mat-icon-button aria-label="Clear" type="button"
                    (click)="detail.value = ''">
                    <fa-icon [icon]="faTimes"></fa-icon>
                  </button>
                </mat-form-field>
                <!-- Number -->
                <mat-form-field *ngIf="getOptionsLength(detail) == 0 && attrDatatype(detail) == 'number'"
                  style="width: 100%">
                  <mat-label>{{detail.roomCustomAttribute.name}}</mat-label>
                  <input [(ngModel)]="detail.value" [required]="isAttrRequired(detail)" [value]="detail.value" matInput
                    type="number" #custDetailNumber id="custDetail{{detail.id}}" name="custDetail{{detail.id}}">
                  <button *ngIf="detail.value"  matSuffix mat-icon-button aria-label="Clear" type="button"
                    (click)="clearDetailValue(detail.roomCustomAttributeId)">
                    <fa-icon [icon]="faTimes"></fa-icon>
                  </button>
                </mat-form-field>

                <!-- Date -->
                <mat-form-field *ngIf="getOptionsLength(detail) == 0 && attrDatatype(detail) == 'date'"
                  style="width: 100%">
                  <mat-label>{{detail.roomCustomAttribute.name}}</mat-label>
                  <input matInput [(ngModel)]="detail.value" name="custDate{{detail.id}}" id="custDate{{detail.id}}"
                    #custDetailDate [matDatepicker]="datePicker" [required]="isAttrRequired(detail)"
                    [value]="detail.value">
                  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                  <mat-datepicker #datePicker></mat-datepicker>
                </mat-form-field>
                <!-- Select -->
                <mat-form-field *ngIf="getOptionsLength(detail) > 0" class="select-form" style="width: 100%;">
                  <mat-select [required]="isAttrRequired(detail)" placeholder='{{getDetailName(detail)}}'
                    name="detailOptions{{detail.id}}" class="filter-select" [(ngModel)]="detail.value"
                    id="custDetail{{detail.id}}" #detailOptionSelect="ngModel">
                    <mat-option *ngFor="let w of getDetailOptions(detail)" [value]="w.value">
                      {{w.display}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <!-- original detail detail -->

                <!-- <mat-form-field>
                    <mat-label>{{detail.roomCustomAttribute.name}}</mat-label>
                    <input [(ngModel)]="detail.value" [value]="detail.value" matInput type="text"
                      [id]="detail.roomCustomAttributeId + 'Input'" [name]="detail.roomCustomAttributeId + 'Input'">
                    <button mat-button *ngIf="detail.value" matSuffix mat-icon-button aria-label="Clear"
                      type="button" (click)="clearDetailValue(detail.roomCustomAttributeId);">
                      <fa-icon [icon]="faTimes"></fa-icon>
                    </button>
                  </mat-form-field> -->
              </div>
              <div class="col-lg-6 col-12">
                <mat-form-field class="select-form" style="width: 100%;">
                  <mat-select placeholder='Status' name="Status" class="filter-select" [(ngModel)]="editRoom.statusId"
                    id="status" #statusSelect="ngModel">
                    <mat-option *ngFor="let w of this.statuses" [value]="w.id">
                      {{w.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- Treatment Dates -->
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <mat-label>
                    Last Treatment Date
                  </mat-label>
                  <input matInput [(ngModel)]="editRoom.lastTreatmentDate" name="lastTreatmentDate"
                    id="lastTreatmentDate" #lastTreatmentDate [matDatepicker]="lastTreatmentDatePicker" (ngModelChange)="setNextTreatmentDate()"
                    [required]="false" [value]="editRoom.lastTreatmentDate">
                  <mat-datepicker-toggle matSuffix [for]="lastTreatmentDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #lastTreatmentDatePicker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Next Treatment Date -->
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <mat-label>
                    Next Treatment Date
                  </mat-label>
                  <input matInput [(ngModel)]="editRoom.nextTreatmentDate" name="nextTreatmentDate"
                    id="nextTreatmentDate" #nextTreatmentDate [matDatepicker]="nextTreatmentDatePicker" 
                    [required]="false" [value]="editRoom.nextTreatmentDate">
                  <mat-datepicker-toggle matSuffix [for]="nextTreatmentDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #nextTreatmentDatePicker></mat-datepicker>
                </mat-form-field>
                <div style="font-size: 70%; color: darkgray;">Treatment Interval: {{this.treatmentInterval}} days</div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="barcode" name="barcode" [(ngModel)]="editRoom.barcode"
                    placeholder='Barcode' [value]="editRoom?.barcode" #barcode="ngModel">
                </mat-form-field>

              </div>
              <div class="col-lg-6 col-12">
                <mat-checkbox placeholder="Active?" name="isActive" id="isActive" [(ngModel)]="editRoom.isActive"
                  [(value)]="editRoom.isActive" #active="ngModel" color="primary">Active?</mat-checkbox>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="row" style="margin-top: 10px;">
     <div class="container">
        <div class="row align-items-center justify-content-between">
            <!-- Save and Cancel -->
            <div class="col-md-auto d-flex align-items-center">
                <!-- Use your existing Angular directives here -->
                <button type="submit" form="RoomForm" class="btn btn-save" (click)="saveRoomClicked(RoomForm)" [disabled]="!RoomForm.valid">Save</button>
                <a class="link-cancel"  (click)="cancelClicked(RoomForm)">Cancel</a>
            </div>

            <!-- Delete Button -->
            <div class="col-md-auto text-end" *ngIf="roomId !== 0">
                <!-- Use your existing Angular directives here -->
                <button class="btn btn-delete" (click)="deleteRoomClicked(RoomForm);">
                    <i class="fas fa-trash-alt fa-lg"></i>
                </button>
            </div>
        </div>
    </div>
  </nb-card-footer>
</nb-card>